/* ===========================================================================
   MM — PARALLAX
   ---------------------------------------------------------------------------
   Un média marqué [data-mm-parallax] glisse un peu moins vite que la page :
   le wrapper rogne (overflow: hidden), le média est agrandi juste assez pour
   couvrir son débattement, et translate en fonction de sa position dans la
   fenêtre. Transform seul, jamais de top/height : tout reste au compositeur.

   L'attribut vit sur le WRAPPER, pas sur le média : image_tag / video_tag ne
   posent pas d'attributs data proprement, et c'est le wrapper qui définit le
   cadre de rognage. Le script anime son premier <img> ou <video>.

   Valeur de l'attribut : la vitesse, en fraction de la hauteur du wrapper
   (défaut .07 — soit ±7 % de débattement). L'agrandissement est déduit :
   scale(1 + 2 × vitesse), le minimum qui couvre le débattement sans marge.

   La boucle rAF ne tourne que quand au moins un média est à l'écran
   (IntersectionObserver) : page sans parallax visible = zéro travail. On lit
   la position au rAF plutôt que sur l'événement scroll : Lenis lisse le
   défilement en continu, l'événement arrive déjà à chaque frame — mais pas
   au chargement ni pendant l'inertie du trackpad sous Safari.

   prefers-reduced-motion : pas de trajet, media remis à plat. La préférence
   est réévaluée en direct (changement système sans recharger).
   =========================================================================== */

(function () {
	'use strict';

	if (window.__mmParallax) return;
	window.__mmParallax = true;

	var DEFAULT_SPEED = 0.07;
	var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

	var items = [];        /* { wrap, media, speed, scale, visible } */
	var byWrap = new WeakMap();
	var rafId = null;

	var io = new IntersectionObserver(function (entries) {
		entries.forEach(function (entry) {
			var item = byWrap.get(entry.target);
			if (item) item.visible = entry.isIntersecting;
		});
		schedule();
	}, {
		/* Marge : le média commence à glisser juste avant d'entrer, pour ne
		   jamais montrer une première frame qui saute. */
		rootMargin: '20% 0px'
	});

	function collect() {
		io.disconnect();
		items = [];
		var wraps = document.querySelectorAll('[data-mm-parallax]');
		Array.prototype.forEach.call(wraps, function (wrap) {
			var media = wrap.querySelector('img, video');
			if (!media) return;
			var speed = parseFloat(wrap.getAttribute('data-mm-parallax'));
			if (isNaN(speed) || speed <= 0) speed = DEFAULT_SPEED;
			var item = {
				wrap: wrap,
				media: media,
				speed: speed,
				scale: 1 + 2 * speed,
				visible: false
			};
			byWrap.set(wrap, item);
			items.push(item);
			io.observe(wrap);
		});
		schedule();
	}

	function reset(item) {
		item.media.style.transform = '';
	}

	function frame() {
		rafId = null;
		if (reduced.matches) {
			items.forEach(reset);
			return;
		}
		var vh = window.innerHeight;
		var running = false;
		items.forEach(function (item) {
			if (!item.visible) return;
			running = true;
			var r = item.wrap.getBoundingClientRect();
			/* Progression -1 → 1 : centre du wrapper vs centre de la fenêtre,
			   normalisée pour couvrir tout le trajet visible. */
			var p = (r.top + r.height / 2 - vh / 2) / ((vh + r.height) / 2);
			if (p < -1) p = -1;
			else if (p > 1) p = 1;
			/* Signe : le média « retarde » sur le défilement. */
			var y = -p * item.speed * r.height;
			item.media.style.transform =
				'translate3d(0,' + y.toFixed(1) + 'px,0) scale(' + item.scale + ')';
		});
		if (running) rafId = requestAnimationFrame(frame);
	}

	function schedule() {
		if (rafId === null) rafId = requestAnimationFrame(frame);
	}

	/* Un changement de préférence en cours de route nettoie ou relance. */
	if (reduced.addEventListener) reduced.addEventListener('change', schedule);

	/* La boucle s'endort quand plus rien n'est visible ; ces signaux la
	   réveillent — l'IO couvre l'entrée d'un média, resize couvre le reste. */
	window.addEventListener('resize', schedule, { passive: true });

	/* L'éditeur de thème recharge des sections entières : on recollecte. */
	document.addEventListener('shopify:section:load', collect);

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', collect);
	} else {
		collect();
	}
})();
